module.exports = __webpack_public_path__ + "img/rino2.562dab84.jpg";